<script>
import Flickity from "vue-flickity";
import Loading from "@/components/layout/Loading.vue";
import { mapActions } from "vuex";

export default {
  components: {
    Flickity,
    Loading,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      widthWindow: 0,
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        draggable: false,
      },
      id_modulo: "3",
    };
  },
  watch: {
    loading() {
      this.$nextTick(() => {
        this.$refs.flickity.rerender();
      });
    },
  },
  mounted() {
    window.addEventListener("resize", this.windowsWidth);
    window.addEventListener("resize", this.updateCarousel);
  },
  methods: {
    ...mapActions("VistosModule", ["insertVisto"]),
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    windowsWidth() {
      this.widthWindow = window.innerWidth;
    },
    updateCarousel() {
      this.$refs.flickity.reposition();
      this.$refs.flickity.resize();
    },

    toDay(date) {
      const newDate = new Date(date);
      if (newDate.getHours() <= 3) {
        newDate.setDate(newDate.getDate() + 1);
      } else {
        newDate.setDate(newDate.getDate());
      }

      return newDate.toLocaleString("es-CL", {
        day: "numeric",
      });
    },

    toMonthName(date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);

      return newDate
        .toLocaleString("es-CL", {
          month: "short",
        })
        .replace(/\./, "");
    },
    async insertVistoNoticia(id_noticia) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_modulo: this.id_modulo,
        id_objeto: id_noticia,
      };

      console.log("datos insert: ", data_);
      await this.insertVisto(data_);
    },
    goToNoticia(id_noticia) {
      this.insertVistoNoticia(id_noticia);
      this.$router.push(`/noticia/${id_noticia}`);
    },
  },
};
</script>
<template>
  <section class="carousel-container">
    <Loading v-if="loading" pixeles="200px" />
    <flickity
			v-else
      ref="flickity"
      class="carousel-custom cursor-p"
      :options="flickityOptions"
    >
      <div
        v-for="noticia in data"
        :key="noticia.id_noticia"
        class="carousel-custom-cell"
        @click="goToNoticia(noticia.id_noticia)"
      >
        <div class="carousel-custom-cell-overlay">
          <span class="carousel-custom-cell-overlay-date">
            {{ toDay(noticia.fecha_noticia) }}
            <small>
              {{ toMonthName(noticia.fecha_noticia) }}
            </small>
          </span>
          <div class="carousel-custom-cell-overlay-title">
            <span>{{ noticia.titulo_noticia }}</span>
          </div>
          <div
            class="carousel-custom-cell-overlay-not-visto"
            v-show="noticia.confirm_visto <= 0"
          >
            <span>Sin leer</span>
          </div>
        </div>
        <img
          class="carousel-custom-cell-img"
          :src="noticia.url_imagen_principal"
        />
      </div>
    </flickity>
    <div
      class="carousel-container-btn-notice d-inline-flex justify-content-end"
    >
      <router-link
        to="/noticias"
        class="btn btn-custom btn-custom-main mt-3 rounded-4 mw-150"
      >
        <font-awesome-icon
          icon="fa-solid fa-newspaper"
          class="pe-2"
        ></font-awesome-icon>
        Ver noticias
      </router-link>
    </div>
    <a
      @click="previous()"
      href="javascript:"
      class="carousel-container-btn carousel-container-btn-left"
    >
      <font-awesome-icon icon="fa-angle-left"></font-awesome-icon>
    </a>
    <a
      @click="next()"
      href="javascript:"
      class="carousel-container-btn carousel-container-btn-right"
    >
      <font-awesome-icon icon="fa-angle-right"></font-awesome-icon>
    </a>
  </section>
</template>
